var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "VBottomSheet",
    {
      attrs: { "hide-overlay": true, persistent: _vm.persistent || null },
      model: {
        value: _vm.showToast,
        callback: function($$v) {
          _vm.showToast = $$v
        },
        expression: "showToast"
      }
    },
    [
      _c(
        "VSheet",
        {
          staticClass: "text-center container",
          class: {
            success: _vm.success,
            error: _vm.error,
            info: _vm.info,
            warning: _vm.warning
          }
        },
        [
          _c("div", { staticClass: "wrapper" }, [
            !_vm.custom
              ? _c(
                  "div",
                  {
                    staticClass: "content",
                    class: {
                      "align-left":
                        _vm.persistent || _vm.ctaButton || _vm.ctaLink,
                      persistent: _vm.persistent && !_vm.forcedCTA
                    }
                  },
                  [
                    _c("div", { staticClass: "toast-simple" }, [
                      _vm.icon &&
                      (_vm.success || _vm.warning || _vm.error || _vm.info)
                        ? _c(
                            "span",
                            { staticClass: "toast-icon" },
                            [
                              _c("NsIcon", {
                                attrs: {
                                  "icon-name": _vm.statusIcon,
                                  size: "icon-lg"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "message" }, [
                        _vm._v(_vm._s(_vm.message))
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.ctaLink || _vm.ctaButton
                      ? _c("div", { staticClass: "cta" }, [
                          _vm.ctaLink
                            ? _c(
                                "a",
                                {
                                  staticClass: "cta-link",
                                  on: { click: _vm.ctaClickHandler }
                                },
                                [_vm._v(_vm._s(_vm.ctaLink))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.ctaButton
                            ? _c(
                                "button",
                                {
                                  staticClass: "primary-solid short",
                                  on: { click: _vm.ctaClickHandler }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.ctaButton) +
                                      "\n          "
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.ctaList &&
                    _vm.ctaList.items &&
                    _vm.ctaList.items.length > 0
                      ? _c(
                          "div",
                          { staticClass: "cta list" },
                          [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.onCtaListOptionSelect(
                                      _vm.ctaList.items[0].id
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.ctaList.items[0].text))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                ref: "chevron",
                                staticClass: "icon chevron-down",
                                on: {
                                  click: function($event) {
                                    _vm.showCtaList = true
                                  }
                                }
                              },
                              [
                                _c("NsIcon", {
                                  attrs: {
                                    "icon-name": "icon-chevron-up",
                                    size: "icon-lg"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "VBottomSheet",
                              {
                                attrs: {
                                  inset: "",
                                  persistent: "",
                                  "hide-overlay": "",
                                  "max-width": "500"
                                },
                                model: {
                                  value: _vm.showCtaList,
                                  callback: function($$v) {
                                    _vm.showCtaList = $$v
                                  },
                                  expression: "showCtaList"
                                }
                              },
                              [
                                _c(
                                  "VSheet",
                                  {
                                    staticClass:
                                      "text-center cta-list-container",
                                    attrs: { "max-height": "90vh" }
                                  },
                                  [
                                    _c("div", { staticClass: "header" }, [
                                      _c("h3", [
                                        _vm._v(_vm._s(_vm.ctaList.title))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "icon close",
                                          on: {
                                            click: function($event) {
                                              return _vm.onCtaListClose()
                                            }
                                          }
                                        },
                                        [
                                          _c("NsIcon", {
                                            attrs: {
                                              "icon-name": "icon-close",
                                              size: "icon-sm"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(_vm._s(_vm.ctaList.subtitle))
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "actions" },
                                      _vm._l(_vm.ctaList.items, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "a",
                                          {
                                            key: index,
                                            on: {
                                              click: function($event) {
                                                return _vm.onCtaListOptionSelect(
                                                  item.id,
                                                  true
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(item.text))]
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.custom
              ? _c(
                  "div",
                  {
                    staticClass: "custom",
                    class: { persistent: _vm.persistent }
                  },
                  [_vm._t("default")],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.persistent && !_vm.forcedCTA
              ? _c(
                  "span",
                  {
                    staticClass: "icon close",
                    on: {
                      click: function($event) {
                        return _vm.onClose()
                      }
                    }
                  },
                  [
                    _c("NsIcon", {
                      staticClass: "chevron-down",
                      attrs: { "icon-name": "icon-close", size: "icon-lg" }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }